import { motion } from "framer-motion";

function scoreColor(score) {
  if (score <= 2) return "#10B981";
  if (score <= 5) return "#F59E0B";
  if (score <= 8) return "#F97316";
  return "#EF4444";
}

export function RiskGauge({ score = 0, size = 200 }) {
  const pct = Math.max(0, Math.min(10, score)) / 10;
  const r = size / 2 - 16;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = Math.PI * r; // half circle
  const dash = circumference * pct;
  const color = scoreColor(score);

  return (
    <div className="relative flex flex-col items-center" data-testid="risk-score-gauge">
      <svg width={size} height={size / 2 + 24} viewBox={`0 0 ${size} ${size / 2 + 24}`}>
        <path
          d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
          fill="none"
          stroke="#1F2937"
          strokeWidth="14"
          strokeLinecap="round"
        />
        <motion.path
          d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
          fill="none"
          stroke={color}
          strokeWidth="14"
          strokeLinecap="round"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: circumference - dash }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        />
      </svg>
      <div className="absolute inset-x-0 top-[38%] flex flex-col items-center">
        <span className="font-heading text-5xl font-extrabold tabular-nums" style={{ color }}>
          {score}
        </span>
        <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">/ 10 risk</span>
      </div>
    </div>
  );
}
